// Truyền Âm (UI_SPEC §17): 5 kênh, mới nhất ở dưới, mở ra cuộn xuống đáy.
import type { JSX } from 'preact';
import { useEffect, useLayoutEffect, useRef, useState } from 'preact/hooks';
import { t } from '@i18n/t';
import { relativeTime } from '@i18n/time';
import {
  LOG_CHANNELS,
  logEntries,
  markChannelRead,
  unreadByChannel,
  type LogChannel,
} from '@state/modules/log';
import { now, onTick } from '@state/clock';
import { Icon } from '../icons';

export function TransmissionTabs({
  channel,
  onSelect,
}: {
  channel: LogChannel;
  onSelect: (c: LogChannel) => void;
}): JSX.Element {
  return (
    <div class="ht-wintabs channels" role="tablist">
      {LOG_CHANNELS.map((c) => (
        <button
          key={c}
          type="button"
          role="tab"
          class="ht-wintab"
          data-id={`channel-${c}`}
          aria-selected={channel === c}
          onClick={() => onSelect(c)}
        >
          <Icon name={c} />
          {t(`ui.channel.${c}`)}
          {unreadByChannel.value[c] > 0 && channel !== c && <span class="ht-dot" aria-hidden="true" />}
        </button>
      ))}
    </div>
  );
}

export function TransmissionBody({ channel }: { channel: LogChannel }): JSX.Element {
  const [nowMs, setNow] = useState(now());
  const endRef = useRef<HTMLDivElement>(null);
  useEffect(() => onTick(setNow), []);
  const lines = logEntries.value.filter((e) => e.channel === channel);
  useEffect(() => {
    markChannelRead(channel);
  }, [channel, lines.length]);
  useLayoutEffect(() => {
    endRef.current?.scrollIntoView({ block: 'end' });
  }, [channel]);
  if (lines.length === 0) return <p class="ht-block">{t('ui.transmission.empty')}</p>;
  return (
    <>
      {lines.map((e, i) => (
        <div class="ht-logline" key={`${e.at}-${i}`} data-id="logline">
          <Icon name={e.channel} />
          <p>
            {t(e.key, e.params)}
            {e.count > 1 ? ` ×${e.count}` : ''}
          </p>
          <time>{relativeTime(e.at, nowMs)}</time>
        </div>
      ))}
      <div ref={endRef} />
    </>
  );
}
